// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3mC8V","colMin":"styles_colMin__2hd3y","colCheckbox":"styles_colCheckbox__2OVeB"};